<template>
  <div>
    <div class="delDaily_body delDaily_input">
      <div class="delDaily_body_main">
        <span>事件日期:</span>
        <el-date-picker
          v-model="dailyDate"
          :clearable="false"
          style=" width: 80%; top:0px"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="delDaily_body_main" style="vertical-align: middle;">
        <span style="vertical-align: middle;display:inline-block">事件时间:</span>

        <div style="display:inline-block;width:80%;vertical-align: middle;">
          <el-time-select
              placeholder="起始时间"
              class="select-time selectLeft"
              style=" top:0px"
              v-model="startHm"
              :clearable="false"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              class="select-time selectRight"
              v-model="endHm"
              :clearable="false"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: startHm
              }">
            </el-time-select>
            <!-- 浮动清了; 我来好吗 难看的要死嘛 -->
            <div class="clear"></div>
        </div>

      </div>
      <div class="delDaily_body_main">
        <span>事件类型:</span>
        <el-select v-model="dailyType" placeholder="全部" style="width:80%" >
          <el-option
            v-for="item in dailyTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="delDaily_foot">
      <el-button @click="submit()" class="submit_button">确定</el-button>
      <el-button @click="cancel()" class="cencel_button">取消</el-button>
    </div>
  </div>
</template>
<script>
import http from '@/api/http'
import * as _ from '@/common/js/config'
export default {
  data() {
    return {
      dailyDate:[(new Date()).toLocaleDateString().split('/').join('-'),(new Date()).toLocaleDateString().split('/').join('-')],
      startHm:"00:00",//起始时间
      endHm:"24:00",//结束时间
      dailyTypeList:[
        {label:"全部" ,value:"0"},
        {label:"晨读会" ,value:"1"},
        {label:"业务学习" ,value:"2"}
      ],
      dailyType:"0",
    }
  },
  methods: {
    submit(){
      if(!this.startHm || !this.endHm){
        this.$message.error("事件时间不能为空");
        return;
      }
      this.$confirm('是否确定要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const  params = {
          confType:this.dailyType,
          startDate :this.dailyDate[0],
          endDate :this.dailyDate[1],
          startTime: this.startHm+":00",
          endTime: this.endHm+":00",
        }

        http.post('/conference/deleteMeetBatch.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.$message.success(res.data.msg);
            this.$emit('delSuccess')
          } else {
            this.$message.error(res.data.msg);
          }
        })
      }).catch((e) => {
        this.$message.error(`网络错误,${e}`);
      });
    },
    cancel(){
      this.$emit("cancelDelDailyMeeting");
    }
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.delDaily_input{
 /deep/ .el-input__inner {
    top:0;
  }
}
.clear{
  clear: both
}
.select-time{
  top: 0px;
  width:49% ;
}
.selectLeft
  float:left
.selectRight
  float:right

.delDaily_body_main
  font-size: 18px;
  margin-bottom: 30px;
.delDaily_body
  height: 150px;
  margin: 25px;
.delDaily_foot {
    width: 100%;
    margin-top: 20px;
    height : 100%;
    text-align: center;

    .submit_button {
      background: #00abad;
      width: 220px;
      text-align: center;
      color: #fff !important;
      border-color: transparent;
    }

    .cencel_button {
      background: #aaadb3;
      width: 220px;
      text-align: center;
      border-color: transparent;
      color: #fff !important;
      margin-left: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// delDailyMeeting.vue?09522421